import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from 'react-router-dom';
import { getApiBaseUrl } from "../../utils/apiConfig";
class RegisterUser extends Component {
    constructor() {
        super();
        this.state = {
            fullName: '',
            userName: '',
            emailAddress: '',
            password: '',
            confirmPassword: ''
        }
    }

    handleChange = (e) => {
        if (e.target.name === "fullName") {
            this.setState({
                fullName: e.target.value
            });
        } else if (e.target.name === "userName") {
            this.setState({
                userName: e.target.value
            });
        } else if (e.target.name === "emailAddress") {
            this.setState({
                emailAddress: e.target.value
            });
        } else if (e.target.name === "password") {
            this.setState({
                password: e.target.value
            });
        } else if (e.target.name === "confirmPassword") {
            this.setState({
                confirmPassword: e.target.value
            });
        }
    }

    handleSubmit = async (e) => {
        let registerDetails = {
            FullName: this.state.fullName,
            UserName: this.state.userName,
            Email: this.state.emailAddress,
            PasswordHash: this.state.password
        };
        if (this.validation()) {
            try {
                const response = await axios.post(getApiBaseUrl() + "/register", registerDetails);
                if(response.status === 200){
                    toast.success("User Created Successfully !!");
                    this.props.navigate('/login');
                } else if(response.status === 201){
                    toast.warning("User already Exists !!");
                }
                console.log(response);
                this.clearForm();
            } catch (error) {
                console.log(error);
            }
        }
    }
    validation = () => {
        var validation = true;
        if (this.state.userName.length === 0 || this.state.emailAddress.length === 0 || this.state.confirmPassword === 0) {
            toast.warning("Please enter all login details!!");
            validation = false;
        }
        if (this.state.confirmPassword !== this.state.password) {
            toast.warning("Password and Confirm Password does not match!!");
            validation = false;
        }

        return validation
    }
    clearForm = async () => {
        this.setState({
            userName: '',
            emailAddress: '',
            password: '',
            confirmPassword: ''
        })
    }
    render() {
        return (
            <>
                <ToastContainer />
                <div className="main-wrapper">
                    <div className="account-content">
                        <div className="login-wrapper">
                            <div className="login-content">
                                <div className="login-userset" style={{ width: "456px" }}>
                                    <div className="login-logo logo-normal">
                                        <img src="assets/img/logo.png" alt="img" />
                                    </div>
                                    <Link href="/" className="login-logo logo-white">
                                        <img src="assets/img/logo-white.png" alt="" />
                                    </Link>
                                    <div className="login-userheading">
                                        <h3>Register</h3>
                                        <h4>Create New Dreamspos Account</h4>
                                    </div>
                                    <div className="form-login">
                                        <label>Full Name</label>
                                        <div className="form-addons">
                                            <input
                                                type="text" className="form-control"
                                                name="fullName"
                                                value={this.state.fullName}
                                                onChange={this.handleChange}
                                            />
                                            <img src="assets/img/icons/user-icon.svg" alt="img" />
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <label>Name</label>
                                        <div className="form-addons">
                                            <input
                                                type="text" className="form-control"
                                                name="userName"
                                                value={this.state.userName}
                                                onChange={this.handleChange}
                                            />
                                            <img src="assets/img/icons/user-icon.svg" alt="img" />
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <label>Email Address</label>
                                        <div className="form-addons">
                                            <input
                                                type="text" className="form-control"
                                                name="emailAddress"
                                                value={this.state.emailAddress}
                                                onChange={this.handleChange}
                                            />
                                            <img src="assets/img/icons/mail.svg" alt="img" />
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <label>Password</label>
                                        <div className="pass-group">
                                            <input
                                                type="password" className="pass-input"
                                                name="password"
                                                value={this.state.password}
                                                onChange={this.handleChange}
                                            />
                                            <span className="fas toggle-password fa-eye-slash"></span>
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <label>Confirm Passworrd</label>
                                        <div className="pass-group">
                                            <input
                                                type="password" className="pass-inputs"
                                                name="confirmPassword"
                                                value={this.state.confirmPassword}
                                                onChange={this.handleChange}
                                            />
                                            <span className="fas toggle-passwords fa-eye-slash"></span>
                                        </div>
                                    </div>
                                    <div className="form-login authentication-check">
                                        <div className="row">
                                            <div className="col-sm-8">
                                                <div className="custom-control custom-checkbox justify-content-start">
                                                    <div className="custom-control custom-checkbox">
                                                        <label className="checkboxs ps-4 mb-0 pb-0 line-height-1">
                                                            <input type="checkbox" />
                                                            <span className="checkmarks"></span>I agree to the <Link to="/" className="hover-a">Terms & Privacy</Link>
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-login">
                                        <button type="submit" onClick={this.handleSubmit} className="btn btn-login">Sign Up</button>
                                    </div>
                                    <div className="signinform">
                                        <h4>Already have an account ? <Link to="/login" className="hover-a">Sign In Instead</Link></h4>
                                    </div>
                                    {/* <div className="form-setlogin or-text">
                                                <h4>OR</h4>
                                            </div>
                                            <div className="form-sociallink">
                                                <ul className="d-flex">
                                                    <li>
                                                        <a href="/" className="facebook-logo">
                                                            <img src="assets/img/icons/facebook-logo.svg" alt="Facebook"/>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="/">
                                                            <img src="assets/img/icons/google.png" alt="Google"/>
                                                        </a>
                                                    </li>
                                                    <li>
                                                        <a href="/" className="apple-logo">
                                                            <img src="assets/img/icons/apple-logo.svg" alt="Apple"/>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div> */}
                                    <div className="my-4 d-flex justify-content-center align-items-center copyright-text">
                                        <p>Copyright &copy; 2023 DreamsPOS. All rights reserved</p>
                                    </div>
                                </div>
                            </div>
                            <div className="login-img">
                                <img src="assets/img/authentication/register02.png" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}
function addHookTo(Component) {
    function CompWithHook(props) {
      const navigate = useNavigate();
  
      return <Component {...props} navigate={navigate} />;
    }
  
    return CompWithHook;
}
  
export default addHookTo(RegisterUser);